exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.dropdown:hover .dropdown-menu {\n  display: block;\n  position: absolute;\n  background: white;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
